// Receiver: the gun's body; every other part hangs off its sockets.
import type { Part } from '../../passes.ts';
import { detailStroke } from '../../passes.ts';
import { line } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

export function receiver(g: GunKit, detail?: Part['detail']): Part {
  const { kind, x, y, w, h } = g.r.receiver;
  const radius = kind === 'round' ? h * 0.45 : kind === 'can' ? 8 : kind === 'long' ? 5 : 4;
  const sw = g.pal.sw(g.r.main);
  return lrect(g, g.r.main, x, y, w, h, radius, {
    detail: (c) => {
      if (kind === 'can') {
        // soda-can rims
        for (const fx of [x + 3, x + w - 3]) {
          detailStroke(
            c,
            line([
              [fx, y + 3],
              [fx, y + h - 3],
            ]),
            sw.light,
            g.ow * 0.9,
          );
        }
      }
      detail?.(c);
    },
  });
}
